import { render, staticRenderFns } from "./CheckBoxCard.vue?vue&type=template&id=8b3156ba&scoped=true"
import script from "./CheckBoxCard.vue?vue&type=script&lang=ts"
export * from "./CheckBoxCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3156ba",
  null
  
)

export default component.exports